import * as React from 'react';
import { IActivityTab } from './interfaces';
import { Box } from '@mui/material';

export const ActivityTab: React.FC<IActivityTab> = ({
  show,
}): JSX.Element | null => {
  if (!show) {
    return null;
  }

  return <Box>Activity</Box>;
};
